<template>
  <div v-if="getDisplayProductOptions" class="productOptions">
    <!-- MF Notes For Product Page -->
    <MfNotes />
    <div class="productOptions__wrapper">
      <div v-if="showSkuOptions" class="productOptions__dropdowns">
        <a
          class="productOptions__dropdowns_clearOptions"
          href="javascript:void(0)"
          @click="clearSelectedOptions"
          v-if="
            getOptionDefinitions.length != 1 &&
              getOptionDefinitions[0].length != 1
          "
          >Clear All</a
        >
        <DropDownOption
          v-for="option in getOptionDefinitions"
          :defaultOption="option"
          :key="option.Key"
          :select-id="deviceType + '-drop-down' + '__' + option.Key"
          :option-key="option.Key"
          :option-name="option.LabelText"
          :skuOptions="getUniqueProductOptions"
          :option-sorting="option.UseContentTreeSorting"
          value
          @update-dropdown="updateDropdown"
        />
      </div>
      <div
        class="productOptions__divider"
        v-if="showSkuOptions || getIsUserLoggedIn"
      ></div>
      <div v-if="displayPrice">
        <ProductPrice :deviceType="deviceType" />
        <ProductCounterAndCartButtonWrapper
          v-if="
            getIsUserLoggedIn &&
              getProductStatus &&
              getProductStatus[0].ShowQuantityCounter
          "
        >
          <div class="productOptions__add-to-cart_wrapper">
            <ProductCartCounter />
          </div>
        </ProductCounterAndCartButtonWrapper>
      </div>
      <div v-else>
        <skeleton
          :loading="!hasProductLoaded || isPricingInProgress"
          width="100%"
          height="123px"
          marginBottom="20px"
        ></skeleton>
      </div>

      <!-- Adding getInventoryData to the condition, so it won't flash '0 in stock' before the call is made to get the actual stock count -->
      <div v-if="displayInventory">
        <ProductInventory
          v-if="
            getInventoryData &&
              displayInventoryData &&
              getIsUserLoggedIn &&
              getProductStatus &&
              getProductStatus[0].ShowInventory
          "
        />
      </div>
      <div v-else>
        <skeleton
          :loading="!inventoryReady"
          width="100%"
          height="123px"
          marginBottom="20px"
        >
        </skeleton>
      </div>
      <ProductLeadTimeBasic
        v-if="
          getIsUserLoggedIn &&
            getProductBrandName.toLowerCase() === 'dalite' &&
            getProductSku
        "
      />
      <div v-if="displayLeadTime">
        <ProductLeadTime
          v-if="
            getIsUserLoggedIn &&
              getInventoryData &&
              showLeadTime &&
              getProductStatus &&
              getProductStatus[0].ShowLeadTime &&
              IsUserRegionUSA != 1 &&
              getProductBrandName &&
              getProductBrandName.toLowerCase() != 'dalite'
          "
          :style-data="leadTimeData"
        />
        <ProductLeadTimeWithState
          v-if="
            getIsUserLoggedIn &&
              getInventoryData &&
              showLeadTime &&
              getProductStatus &&
              getProductStatus[0].ShowLeadTime &&
              IsUserRegionUSA &&
              getShowStatesOnPDP &&
              getProductBrandName &&
              getProductBrandName.toLowerCase() != 'dalite'
          "
          :style-data="leadTimeData"
        />
        <div
          class="productOptions__shippingTimeMessage"
          v-if="
            getIsUserLoggedIn &&
              getProductStatus &&
              getProductStatus[0].ProductStatus === 'Coming Soon' &&
              getProductSku &&
              getProductSku.ShippingTimeMessage !== ''
          "
        >
          {{ getProductSku.ShippingTimeMessage.substring(0, 40) }}
        </div>
      </div>
      <div v-else>
        <skeleton
          :loading="!leadTimeReady"
          width="100%"
          height="123px"
          marginBottom="20px"
        ></skeleton>
      </div>
      <ProductAddToCart
        class="productOptions__add_to_cart_button_with_counter"
        v-if="getIsUserLoggedIn"
        :isDisabled="isAddToCartDisabled"
      />
      <ProductAddToCart
        v-if="getIsUserLoggedIn"
        class="productOptions__add-to-quote"
        :is-quote="true"
        :isDisabled="isAddToQuoteDisabled"
      />
    </div>
    <ProductOptionsStatus
      v-if="
        getProductStatus && getProductStatus[0].ProductStatus === 'Coming Soon'
      "
    />

    <ProductIsConfigurable :deviceType="deviceType" />
    <!-- added reference for compatibility component loading -->
    <ProductCompatibilityChecker ref="productCompatibilityChecker" />
  </div>
  <div v-else class="container-unavailable"> 
  
   <div class="unavaialble-product-text" > {{getProductNotAvailableText}}</div>
  
  </div>
</template>
<script>
import ProductPrice from "./ProductPrice";
import ProductAddToCart from "./ProductAddToCart";
import ProductIsConfigurable from "./ProductIsConfigurable";
import DropDownOption from "./options/DropDownOption";
import ProductInventory from "./ProductInventory.vue";
import ProductLeadTime from "./ProductLeadTime";
import ProductLeadTimeBasic from "./ProductLeadTimeBasic";
import MfNotes from "./MfNotes.vue";
import ProductLeadTimeWithState from "./ProductLeadTimeWithState.vue";
import ProductCartCounter from "./ProductCartCounter";
import ProductCounterAndCartButtonWrapper from "./ProductCounterAndCartButtonWrapper";
import ProductCompatibilityChecker from "./ProductCompatibilityChecker";
import Skeleton from "../shared/ProductSkeleton";
import ProductOptionsStatus from "./ProductOptionsStatus";

import { mapGetters } from "vuex";

export default {
  props: {
    deviceType: {
      type: String,
      default: " "
    }
  },
  data() {
    return {};
  },
  mounted() {
    // this is so it only runs this code once
    if (this.isFirstRun) {
      this.$store.dispatch("product/updateIsFirstRun", false);
    } else {
      return;
    }

    const sku = this.getProductSku;

    if (sku && !this.showProductOptions && this.$route.query["sc_lang"]) {
      // if they change the Region from the header and the sku doesn't
      // have option values, redirect to the series.
      window.location = this.getProductSeries.Url;
    } else if (sku && sku.OptionValues) {
      // if product is displaying a sku page and the sku has options
      // all sku options have been selected,
      // so add each option to the state selected options array
      sku.OptionValues.forEach(option => {
        this.$store.dispatch("product/selectOption", {
          Key: option.Key,
          Value: option.Value
        });
      });
    } else {
      // this is a series page without all selected options

      const { query } = this.$route;
      // update any dropdowns with values from the query string
      Object.keys(query).forEach(key => {
        this.updateDropdown({
          Key: key,
          Value: query[key],
          calledFromMountedEvent: true
        });
      });
    }

    if (this.getIsUserLoggedIn) {
      const productNumber = this.getProductSku?.SkuCode;
      const customerNumber = this.getUser?.CustomerNumber;
      if (productNumber && customerNumber) {
        this.$store.dispatch("inventory/loadInventoryData", {
          productNumber,
          customerNumber
        });
      }
    }
    // Make the manufacturer API call to avoid calling thrice
    this.$refs.productCompatibilityChecker.loadManufacturersOnMount();
  },
  computed: {
    ...mapGetters("product", [
      "getOptionDefinitions",
      "getSkus",
      "getSeriesId",
      "getProduct",
      "getProductOptimized",
      "getProductSku",
      "getProductBrandName",
      "isFirstRun",
      "getProductSeries",
      "getSelectedOptions",
      "getDisplayProductOptions",
      "getUniqueProductOptions",
      "getProductFormattedPrice",
      "getPriceReplaceMessage",
      "getProductStatus",
      "isPricingInProgress",
      "hasPricingLoaded",
      "hasProductLoaded",
      "hasPrice",
      "getProductNotAvailableText"
    ]),
    ...mapGetters("user", ["getIsUserLoggedIn", "getUser"]),
    ...mapGetters("user", ["getShowStatesOnPDP", "getUser"]),
    ...mapGetters("inventory", [
      "getInventoryStatusCode",
      "getSAPStatusCode",
      "getInventoryData"
    ]),
    IsUserRegionUSA() {
      if (this.getIsUserLoggedIn) {
        const userCookie = window.$cookies.get("Milestone_ClientRegion");
        if (
          userCookie != "{1FA20C51-0AB9-4DAB-B6A0-DB52A129C0AF}" ||
          this.getShowStatesOnPDP != true
        ) {
          return 0;
        } else {
          return 1;
        }
      } else {
        return 0;
      }
    },
    showSkuOptions() {
      return (
        this.getOptionDefinitions &&
        this.getOptionDefinitions.length > 0 &&
        this.getDisplayProductOptions
      );
    },
    showLeadTime() {
      // Note:- Avi 03-06-2022: Added this logic to hide lead time component
      // when SAP status code is 99 and the inventory has availability
      if (this.getSAPStatusCode == 99 && this.getInventoryStatusCode == 1)
        return false;
      else if (this.getProductSku && this.getProductSku.SAPLeadTime)
        return true;
      else return false;
    },
    leadTimeData() {
      if (this.getProductSku && this.getProductSku.SAPLeadTime)
        return this.getProductSku.SAPLeadTime;
      else return [];
    },

    displayInventoryData() {
      // NOTE: Andy 11-30-21 In the future this logic should be primarily handeled on the backend
      // If you are making changes to this method, consider refactoring the service and simplfying this logic
      // Any changes to this logic need to be reflected on the front end and back end
      const inventoryStatusCodeHasInventory = 1;
      const inventoryStatusCodeNoInventory = 0;
      const inventoryStatusCodeNoInventoryAlternateValue = null;
      //const sapProductDiscontinued = 86;
      const sapCallForAvailability = 99;
      //const sapCallForAvailabilityAlternateValue = 0;
      //const sapOrderThroughCustomerCare = 98;

      // This if checks getInventoryStatusCode for 3 cases where we might display inventory component
      // case 1 means there is inventory
      // case 0 means no inventory
      // case null inventory status code is null is the same as 0 but not explictly sent
      // the else case would be when getInventoryStatusCode is undefined
      // Note:- Avi 03-06-2022: Making this equal since for some products, we need to show inventory even if sap returns status code of 99
      if (
        this.getProductSku &&
        (this.getInventoryStatusCode == inventoryStatusCodeHasInventory ||
          this.getInventoryStatusCode == inventoryStatusCodeNoInventory ||
          this.getInventoryStatusCode ==
            inventoryStatusCodeNoInventoryAlternateValue ||
          this.getSAPStatusCode == sapCallForAvailability)
      ) {
        return true;
      } else return false;
    },
    isAddToCartDisabled() {
      // Check if getProductStatus is null or undefined
      if (!this.getProductStatus || this.getProductStatus.length === 0) {
        return true; // Disable if getProductStatus is null or empty
      }

      // Check if ShowAddToCart is false or priceReady is false
      if (
        !this.getProductStatus[0].ShowAddToCart ||
        !this.priceReady ||
        !this.hasPrice
      ) {
        return true; // Disable if ShowAddToCart is false, priceReady is false, or price is <= 0
      }
      return false; // Otherwise, the button is enabled
    },
    isAddToQuoteDisabled() {
      // Check if getProductStatus is null or undefined
      if (!this.getProductStatus || this.getProductStatus.length === 0) {
        return true; // Disable if getProductStatus is null or empty
      }

      // Check if ShowAddToCart is false or priceReady is false
      if (
        !this.getProductStatus[0].ShowAddToQuote ||
        !this.priceReady ||
        !this.hasPrice
      ) {
        return true; // Disable if ShowAddToCart is false or priceReady is false
      }
      return false; // Otherwise, the button is enabled
    },
    displayPrice() {
      if (!this.getIsUserLoggedIn) return true;
      if (!this.hasProductLoaded || !this.hasPricingLoaded) return false;
      return true;
    },
    displayInventory() {
      if (!this.getIsUserLoggedIn) return true;
      if (this.inventoryReady) {
        return true;
      }
      return false;
    },
    displayLeadTime() {
      if (!this.getIsUserLoggedIn) return true;
      if (this.leadTimeReady) {
        return true;
      }
      return false;
    },
    inventoryReady() {
      if (!this.hasProductLoaded) return false;
      // If we aren't supposed to show inventory data, don't wait
      if (!this.displayInventoryData) return true;
      // If we are supposed to show the data, wait for it
      else {
        let inventoryCount = -1;
        inventoryCount = this.getInventoryDataInfo();
        return inventoryCount >= 0;
      }
    },
    priceReady() {
      if (!this.hasProductLoaded) return false;
      // If the price replacement message has a message, don't wait for price
      if (this.getPriceReplaceMessage) {
        return true;
      } else {
        // Wait for price, this will return whether or not there is a message in the Formatted Price
        return Boolean(this.getProductFormattedPrice);
      }
    },
    leadTimeReady() {
      if (!this.hasProductLoaded) return false;
      if (!this.showLeadTime || !this.getProductStatus[0].ShowLeadTime) {
        return true;
      }
      return this.getProductStatus && this.getProductStatus[0].ShowLeadTime;
    }
  },
  methods: {
    updateDropdown(updated, isClearEvent = false) {
      const lastSelectedSkuCode = this.getSelectedSku;
      const lastSelectedSeries = this.getSeriesId;
      this.$store.dispatch("product/selectOption", updated).then(() => {
        const selectedOptions = this.getSelectedOptions;
        let skus = this.getSkus;

        // Early return if no options or skus
        if (!isClearEvent && (!selectedOptions?.length || !skus?.length))
          return;

        // Use reduce instead of forEach + filter for better performance
        skus = selectedOptions.reduce((filteredSkus, element) => {
          return filteredSkus.filter(sku =>
            sku.OptionValues?.some(
              optionvalue =>
                optionvalue.Key === element.Key &&
                optionvalue.Value === element.Value
            )
          );
        }, skus);

        const seriesId = this.getSeriesId;
        // Single SKU case
        if (skus?.length === 1) {
          const sku = skus[0];
          const skuId = sku.SitecoreId;
          const skuCode = sku.SkuCode;

          if (lastSelectedSkuCode !== skuCode) {
            // Batch dispatch actions
            Promise.all([
              this.$store.dispatch("product/loadProduct", {
                seriesId,
                skuId,
                useOptimProduct: true
              }),
              this.$store.dispatch(
                "prodspecification/loadProductSpecification",
                {
                  seriesId,
                  skuId
                }
              ),
              this.$store.dispatch("resources/loadProductResource", {
                seriesId,
                skuId
              }),
              this.$store.dispatch("product/updateIsBreadCrumbsLoading", true),
              this.$store.dispatch("product/loadBreadCrumbs", {
                seriesId,
                skuId
              }),
              this.$store.dispatch("product/loadProductPrice", {
                store: this.$store,
                skuCode: skuCode
              })
            ]).then(() => {
              if (this.getProduct.SelectedSku) {
                const optionPromises = this.getProduct.SelectedSku.OptionValues.map(
                  opt => {
                    opt.fromService = true;
                    return this.$store.dispatch("product/selectOption", opt);
                  }
                );
                Promise.all(optionPromises);
              }
              const productNumber = this.getProductSku?.SkuCode;
              const customerNumber = this.getUser?.CustomerNumber;
              if (productNumber && customerNumber) {
                this.$store.dispatch("inventory/loadInventoryData", {
                  productNumber,
                  customerNumber
                });
              }
              this.$router.push({ path: sku.Url }).catch(() => {});
            });
          }
        }
        // Multiple SKUs case
        else if (!updated.calledFromMountedEvent) {
          const series = this.getProductSeries;
          const query = selectedOptions?.reduce((acc, element) => {
            acc[element.Key] = element.Value;
            return acc;
          }, {});

          if (isClearEvent || lastSelectedSeries !== seriesId) {
            Promise.all([
              this.$store.dispatch(
                "prodspecification/loadProductSpecification",
                {
                  seriesId
                }
              ),
              this.$store.dispatch("resources/loadProductResource", {
                seriesId
              }),
              this.$store.dispatch("product/loadProductNoSkeleton", {
                seriesId,
                useOptimProduct: true
              })
            ]).then(() => {
              this.$router
                .push({
                  path: series.Url,
                  query
                })
                .catch(() => {});
            });
          }
        }
      });
    },
    clearSelectedOptions() {
      this.$store
        .dispatch("product/clearSelectedOption", this.getProductSeries)
        .then(() => {
          this.updateDropdown({}, true);
        });
    },
    getInventoryDataInfo() {
      const inventoryInfo = this.getInventoryData;
      let inventoryTotal = 0;
      if (this.getInventoryStatusCode == 0) return 0;
      if (inventoryInfo && inventoryInfo.AvailableInventoryList) {
        inventoryInfo.AvailableInventoryList.forEach(element => {
          inventoryTotal = inventoryTotal + element.CommittedQty;
        });
      }
      return inventoryTotal;
    }
  },
  components: {
    DropDownOption,
    ProductPrice,
    ProductAddToCart,
    ProductLeadTime,
    ProductLeadTimeBasic,
    MfNotes,
    ProductLeadTimeWithState,
    ProductIsConfigurable,
    ProductInventory,
    ProductCartCounter,
    ProductCounterAndCartButtonWrapper,
    ProductCompatibilityChecker,
    ProductOptionsStatus,
    Skeleton
  }
};
window.onpopstate = function() {
  location.reload();
};
</script>
<style lang="scss" scoped>
.productOptions {
  text-align: left;
  letter-spacing: 0.25px;
  line-height: 24px;
  font-family: $font-family-sans-serif-regular;
  font-size: 16px;

  &__divider {
    border-bottom: 3px solid #a8a8a8;
  }

  @include media-breakpoint-up(lg) {
    display: block;
  }
  &__wrapper {
    padding-bottom: 25px;

    @include media-breakpoint-up(sm) {
      border: 1px solid $gray;
      padding: 20px 20px 25px 20px;
      margin-bottom: 25px;
    }
  }
  &__dropdowns {
    margin-bottom: 25px;
    position: relative;

    &_clearOptions {
      position: absolute;
      right: 0;
      color: $primary;
      font-family: $body;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.2px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__add-to-cart_wrapper {
    display: flex;
    flex-direction: column;
  }
  &__foo {
    border-top: 3px solid #a8a8a8;
    padding-top: 25px;
    margin-top: 15px;
  }
  &__shippingTimeMessage {
    font-family: $body;
    color: $primary;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0.2px;
    line-height: 24px;
    margin-top: 16px;
  }
  &__add_to_cart_button_with_counter {
    margin-top: 30px;
    //  width: 230px;
  }
  &__add_to_cart_button_disabled {
    margin-top: 30px;
    background: #e6e6e6;
  }
  &__add-to-quote {
    border-top: 3px solid #e5e5e5;
    margin-top: 16px;
    @include media-breakpoint-up(sm) {
      border-top: none;
      padding-top: 0;
    }
  }
}

.required-product-link {
  text-decoration: underline;
  color: $primary;
  &:hover {
    color: $primary-300;
  }

  &:focus {
    color: $primary-300;
    @include focus_outline();
  }
}
.unavaialble-product-text {  
  color: red;
  font-family: $body;
  border-width: 8px !important;
  font-weight: 600;
  border: solid;
  position: absolute;
  right: 30px;
  top: 343px;
  font-size: 30px;
  text-wrap: wrap;
  width: 330px;
  transform: rotate(45deg) !important;
  transform: translate(-50%, -50%);
}
@media (max-width: 765px) and (min-width: 10px) {
  .unavaialble-product-text {
  color: red;
  font-family: $body;
  border-width: 8px !important;
  font-weight: 600 !important;
  border: solid;
  position: absolute;
  left:23px;
  top: 670px;
  font-size: 30px;  
  text-wrap: wrap;
  width: 330px;
  transform: rotate(45deg) !important;
  }
}


.container-unavailable{
height: 600px;
}
</style>
